module.exports = __webpack_public_path__ + "img/popupimg.2c326091.png";